<template>
  <form @submit.prevent="onSubmit">
    <div class="wizard-header">
      <h3 class="wizard-title">{{ wizardTitle }}</h3>
      <p class="category">{{ wizardDescription }}</p>
    </div>
    <insurers></insurers>

    <wizard-navigation :step="step" style="margin-bottom:5.5rem;"></wizard-navigation>

    <payment-page :stripePk="this.stripePk"></payment-page>
  </form>
</template>

<script>
import moment from "moment";
import { mapActions, mapState, mapGetters } from "vuex";
import store from "../store";
import SimpleGoogleMap from "./SimpleGoogleMap.vue";
import * as appConfigs from "../configs";
import Cookies from "js-cookie";
import { generateErrorMessage } from "../helpers";
import Datepicker from "vuejs-datepicker";
import { padStart, isEmpty } from "lodash";
import swal from "sweetalert";
import WizardNavigation from "./WizardNavigation";
import SummaryEndorsements from "./SummaryEndorsements";
import OrderSummary from "./OrderSummary";
import PaymentPage from "./common/PaymentPage";


export default {
  store,
  components: {
    SimpleGoogleMap,
    Datepicker,
    WizardNavigation,
    SummaryEndorsements,
    OrderSummary,
    PaymentPage
  },
  mounted() {
  },
  data: function () {
    return {
      step: 5,
      fields: {
        payment_type: "",
        card_exp_month: "",
        card_name: "",
        card_number: "",
        card_exp_year: "",
        card_cvc: "",
        business_address_line_1: "",
        business_address_suburb: "",
        business_address_state: "",
        business_address_postcode: "",
        business_address_country: "",
        business_address_lat: "",
        business_address_lng: "",
        postal_address_line_1: "",
        postal_address_suburb: "",
        postal_address_state: "",
        postal_address_postcode: "",
        postal_address_country: "",
        postal_address_lat: "",
        postal_address_lng: "",
        abn: "",
        insurance_starts_at: null,
      },
      accepts: false,
      disabledDates: {
        customPredictor(date) {
          // const dateFrom = moment(new Date())
          // 	.startOf('day')
          // 	.add(date.getHours() >= 17 ? 1 : 0, 'days')
          const dateFrom = moment(new Date()).startOf("day").add(1, "days");
          const dateTo = moment(new Date()).startOf("day").add(30, "days");

          date = moment(date).startOf("day");
          return date < dateFrom || date > dateTo;
        },
      },
      userConfirmedSubmission: false,
      postal_address_same_as_business_address: false,
    };
  },
  computed: {
    ...mapGetters(["isExemptFromStampDuty", "totalCostOfInsurance"]),

    disableButton() {
      // Disable button for credit card checkout
      if (this.fields.payment_type == "credit_card") {
        // Validate business address, postal address and insurance start date
        return !(
          this.isBusinessAddressProvided &&
          this.isPostalAddressProvided &&
          this.fields.insurance_starts_at
        );
      }

      // Disable button for pay in 7 days
      if (this.fields.payment_type == "bank_transfer") {
        // Validate business address, postal address, insurance start date and terms&cond
        return !(
          this.isBusinessAddressProvided &&
          this.isPostalAddressProvided &&
          this.fields.insurance_starts_at &&
          this.accepts
        );
      }

      // Disable button for Pay by Month
      if (this.fields.payment_type == "efund") {
        // Validate business address, postal address and insurance start date
        return !(
          this.isBusinessAddressProvided &&
          this.isPostalAddressProvided &&
          this.fields.insurance_starts_at
        );
      }

      return true;
    },
    canSetPostalAddressSameAsBusinessAddress() {
      // if the lat of business address is not blank, then user has already picked business address
      // return this.fields.business_address_lat != ''
      return true;
    },
    ...mapState({
      configs: (state) => state.configs,
      summaryData: (state) => state.summaryData,
      accidentCover: (state) => state.accidentCover,
      pendingOrder: (state) => state.pendingOrder,
    }),

    pendingOrderId() {
      if (typeof Cookies.get("pendingOrderId") != "undefined") {
        return Cookies.get("pendingOrderId");
      }

      return false;
    },
    creditCardUrl() {
      return appConfigs.apiDomain + "images/credit-card.png";
    },
    dutyOfDisclosureUrl() {
      return appConfigs.dutyOfDisclosureUrl;
    },
    eFundInterestRate() {
      return appConfigs.eFundInterestRate;
    },
    insuranceStartsDate() {
      return this.fields.insurance_starts_at
        ? moment(this.fields.insurance_starts_at).format("Do MMMM YYYY")
        : null;
    },
    adjustedTotal() {
      var total = this.summaryData.totalPrice;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }

      return (total * this.eFundInterestRate).toFixed(2);
    },
    monthlyPayment() {
      let monthlyPayments = this.totalCostOfInsurance
        ? (this.adjustedTotal / 10).toFixed(2)
        : 0.0;
      // this.updateMonthlyPayment({ monthlyPayment  })
      return monthlyPayments;
    },
    eFundAvailable() {
      return this.summaryData.period_of_cover == 12;
    },
    isBusinessAddressProvided() {
      return !!(
        this.fields.business_address_line_1 &&
        this.fields.business_address_suburb &&
        this.fields.business_address_state &&
        this.fields.business_address_postcode
      );
    },
    isPostalAddressProvided() {
      return !!(
        this.fields.postal_address_line_1 &&
        this.fields.postal_address_suburb &&
        this.fields.postal_address_state &&
        this.fields.postal_address_postcode
      );
    },
  },
  watch: {
    "fields.payment_type"(value) {
      if (value == "credit_card") {
        this.$store.commit("setUsingCreditCard", { trueOrFalse: true });
      } else {
        this.$store.commit("setUsingCreditCard", { trueOrFalse: false });
      }
    },
    postal_address_same_as_business_address(value) {
      if (value) {
        this.copyBusinessAddressToPostalAddress();
      } else {
        this.resetPostalAddress();
      }
    },
  },
  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
    }),
    confirmFormSubmission() {
      if (this.userConfirmedSubmission) {
        goog_report_conversion();
        this.submitForm();
        return;
      }
      if(this.fields.payment_type === null || this.fields.payment_type === ""){
        swal('', 'Please select a payment type, Thank you.', 'error');
      }else{
        swal({
          icon: "info",
          title: "Are you sure?",
          text:
            "Once you click confirm, your order will be processed.  If you chose credit card as your payment method, you will only be charged if insurance is approved and finalised, otherwise the funds will be released after 7 days.",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: "Confirm",
              value: true,
              closeModal: true,
            },
          },
        }).then((value) => {
          if (value) {
            this.userConfirmedSubmission = true;
            this.submitForm();
          }
        });
      }
    },
    submitForm() {
      let vm = this;
      vm.$store.commit("setScreenLoader", { showScreenLoader: true });
      axios
        .post(
          appConfigs.validateUrl,
          Object.assign(
            {},
            vm.fields,
            { step: vm.step },
            { id: vm.pendingOrder.id }
          )
        )
        .then((response) => {
          vm.$store.commit("setScreenLoader", { showScreenLoader: false });
          vm.$store.commit("setEFundResponse", {
            eFundResponse: response.data.eFundResponse,
          });
          vm.$store.commit("setOrderId", { orderId: response.data.orderId });

          Cookies.remove("pendingOrderId");
          vm.$store.commit("resetState");
        })
        .catch((error) => {
          let errorMessage = generateErrorMessage(error);
          vm.$store.commit("setError", { error: errorMessage });
          vm.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },
    previousClicked() {
      this.$store.commit("decrementStep");
      this.$store.commit("clearError");
      this.scrollToTop();
    },
    copyBusinessAddressToPostalAddress() {
      this.fields.postal_address_line_1 = this.fields.business_address_line_1;
      this.fields.postal_address_suburb = this.fields.business_address_suburb;
      this.fields.postal_address_state = this.fields.business_address_state;
      this.fields.postal_address_postcode = this.fields.business_address_postcode;
      this.fields.postal_address_country = this.fields.business_address_country;
      this.fields.postal_address_lat = this.fields.business_address_lat;
      this.fields.postal_address_lng = this.fields.business_address_lng;
    },
    resetPostalAddress() {
      this.fields.postal_address_line_1 = "";
      this.fields.postal_address_suburb = "";
      this.fields.postal_address_state = "";
      this.fields.postal_address_postcode = "";
      this.fields.postal_address_country = "";
      this.fields.postal_address_lat = "";
      this.fields.postal_address_lng = "";
    },
    bindGoogleAddressPicker(addressPrefix, event) {
      let vm = this;
      let autocomplete = new google.maps.places.Autocomplete(
        event.currentTarget,
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      autocomplete.addListener("place_changed", function () {
        let place = autocomplete.getPlace();
        vm.fields[
          addressPrefix + "_address_lat"
        ] = place.geometry.location.lat();
        vm.fields[
          addressPrefix + "_address_lng"
        ] = place.geometry.location.lng();

        vm.fields[addressPrefix + "_address_line_1"] = place.formatted_address;
        place.address_components.map(function (component) {
          if (component.types[0] == "locality") {
            vm.fields[addressPrefix + "_address_suburb"] = component.long_name;
          } else if (component.types[0] == "administrative_area_level_1") {
            vm.fields[addressPrefix + "_address_state"] = component.short_name;
          } else if (component.types[0] == "postal_code") {
            vm.fields[addressPrefix + "_address_postcode"] =
              component.short_name;
          } else if (component.types[0] == "country") {
            vm.fields[addressPrefix + "_address_country"] = component.long_name;
          }
        });
      });
    },
    formatMonthNumber(value) {
      return padStart(value, 2, 0);
    },
  },
  props: {
    wizardTitle: {
      type: String,
      required: true,
    },
    wizardDescription: {
      type: String,
      required: true,
    },
    infoText: {
      type: String,
      required: true,
    },
    stripePk: {
      type: String, 
      required:true, 
    }
  },
};
</script>

<style lang="scss">
@import "../../sass/form/global";
@import "../../sass/form/sweetalert";

.pointer-cursor {
  cursor: pointer !important;
}
.bd-faded {
  background: #f3f2ee !important;
}
.up {
  width: 100% !important;
  font-weight: bold;
}
.prev {
  position: absolute !important;
  left: 0 !important;
}
.next {
  position: absolute !important;
  right: 0 !important;
}
.prev,
.next {
  background: none !important;
}
.vdp-datepicker__calendar {
  background-color: #f3f2ee !important;
  border: 1px solid #e8e7e3 !important;
  border-radius: 4px !important;
  color: #66615b !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06), 0 3px 6px rgba(0, 0, 0, 0.13) !important;
}

.vdpRow .disabled{
    color: #fff !important;
    display:table-cell !important;
}


@media screen and (max-width: 768px) {
  .sm-m-b-10 {
    margin-bottom: 10px !important;
  }
}

@media screen and (max-width: 320px) {
  .alert-simple {
    p {
      font-size: 12px;
    }
  }
}


</style>
